import './registerServiceWorker'
import '@/class-component-hooks'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import PerfectScrollbar from 'vue2-perfect-scrollbar'

import '@mdi/font/css/materialdesignicons.min.css'
import './theme/index.scss'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import vuetify from './plugins/vuetify'

Vue.use(PerfectScrollbar)
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
